import {
    BillingNotAvailableContainerStyled,
    BillingNotAvailableContentStyled,
} from './styled/BillingNotAvailableStyled';
import { BinIcon } from '../../../components/icon/Icon';
import { Button } from 'react-bootstrap';
import { closeModalAction } from '../../../app/appActions';
import { connect } from 'react-redux';
import { isClientMobile } from '../../../components/ClientInfo/ClientInfo';
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext.js";

const BillingNotAvailable = ({ closeModal }) => {
    const { getLangPath } = useLangContext();
    return (
        <BillingNotAvailableContainerStyled>
            <BillingNotAvailableContentStyled>
                <BinIcon name="IcExclamationMarkCircle" className="mb-3" style={{ fontSize: '56px', fill: 'var(--color-red)' }} />
                <h4 className="mb-3" style={{ maxWidth: '150px' }}>
                    {getLangPath('error.default_message')}
                </h4>
                <p style={{ marginBottom: 0 }}>{getLangPath('error.request_text')}</p>
                {!isClientMobile && (
                    <Button
                        variant="primary"
                        size="lg"
                        onClick={closeModal}
                        style={{ width: '100%', marginTop: '32px' }}
                    >
                        {getLangPath('error.request_button')}
                    </Button>
                )}
            </BillingNotAvailableContentStyled>
        </BillingNotAvailableContainerStyled>
    );
};

const mapDispatchToProps = (dispatch) => ({
    closeModal: (payload) => dispatch(closeModalAction(payload)),
});

export default connect(null, mapDispatchToProps)(BillingNotAvailable);
